import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import Field from "./Field";
import { attrDescriptor } from "../descriptors";
/**
 * @memberof module:fields
 */

export var Attribute =
/*#__PURE__*/
function (_Field) {
  _inheritsLoose(Attribute, _Field);

  function Attribute(opts) {
    var _this;

    _this = _Field.call(this) || this;
    _this.opts = opts || {};

    if (_this.opts.hasOwnProperty("getDefault")) {
      _this.getDefault = _this.opts.getDefault;
    }

    return _this;
  }

  var _proto = Attribute.prototype;

  _proto.createForwardsDescriptor = function createForwardsDescriptor(fieldName, model) {
    return attrDescriptor(fieldName);
  };

  return Attribute;
}(Field);
export default Attribute;